import React from 'react';
import { SvgIconProps } from '@mui/material';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { CollaborationStepType } from '@services/collaboration-plan.service';

interface CollaborationStepVisual {
  Icon: React.ComponentType<SvgIconProps>;
  color: string;
  bg: string;
}

// MUI-іконки звірені з оригінальними SVG із Figma (назви видно в коментарях вихідного CSS: "Icon
// Insert chart", "Find in page", "Icon Notifications", "Videocam"). Калькар "календар з крапками"
// (schedule_first_consultation/schedule_repeat_meeting) - не знайдено точного MUI-відповідника,
// взято найближчий `CalendarMonthOutlined` (не піксель-в-піксель, прийнятно для мок-дизайну).
export const COLLABORATION_STEP_VISUALS: Record<CollaborationStepType, CollaborationStepVisual> = {
  personal_questionnaire:      { Icon: ListAltOutlinedIcon,          color: '#41AEE4', bg: '#ECF7FC' },
  schedule_first_consultation: { Icon: CalendarMonthOutlinedIcon,    color: '#6EB52C', bg: '#EFF6E9' },
  first_meeting:                { Icon: VideocamOutlinedIcon,        color: '#3C82F6', bg: '#EBF2FE' },
  meeting_summary:              { Icon: ListAltOutlinedIcon,         color: '#D183FF', bg: '#FAF3FF' },
  create_client_plan:           { Icon: CreateNewFolderOutlinedIcon, color: '#F2C955', bg: '#FEFAEE' },
  schedule_repeat_meeting:      { Icon: CalendarMonthOutlinedIcon,   color: '#6EB52C', bg: '#EFF6E9' },
  progress_review_send:         { Icon: InsertChartOutlinedIcon,     color: '#3C82F6', bg: '#EBF2FE' },
  progress_review_view:         { Icon: FindInPageOutlinedIcon,      color: '#FF7070', bg: '#FFF1F1' },
  progress_review_remind:       { Icon: NotificationsOutlinedIcon,   color: '#3C82F6', bg: '#EBF2FE' },
  repeat_meeting:                { Icon: VideocamOutlinedIcon,       color: '#3C82F6', bg: '#EBF2FE' },
  // Довільна задача - дизайном не описана, нейтральний сірий.
  custom:                        { Icon: ListAltOutlinedIcon,        color: '#989898', bg: '#F2F2F2' },
};
